import { store } from "rfx-core";

import AppStore from "./modules/principal/stores/AppStore";
import LoginStore from "./modules/login/stores/LoginStore";
import TabelaStore from "./modules/comum/stores/TabelaStore";
import ModalStoreCustom from "./modules/comum/modal/stores/ModalStore";
import ModalStore from "./modules/comum/stores/ModalStore";
import FormStore from "./modules/comum/stores/FormStore";
import ValidacaoStore from "./modules/comum/stores/ValidacaoStore";
import LoadingPanelStore from "./modules/comum/stores/LoadingPanelStore";
import TituloPaginaStore from "./modules/comum/stores/TituloPaginaStore";
import ParametrosStore from "./modules/principal/stores/ParametrosStore";

export default store.setup({
    appStore: AppStore,
    loginStore: LoginStore,
    tabelaStore: TabelaStore,
    modalStore: ModalStore,
    modalStoreCustom: ModalStoreCustom,
    formStore: FormStore,
    validacaoStore: ValidacaoStore,
    loadingPanelStore: LoadingPanelStore,
    tituloPaginaStore: TituloPaginaStore,
    parametrosStore: ParametrosStore
});


// WEBPACK FOOTER //
// ./src/stores.js